import { i18n, SupportedLanguages } from '../../i18n/i18n.js';

export class LanguageSwitcher {
  constructor(container) {
    this.container = container;
    this.element = null;
  }

  render() {
    if (!this.container) return;

    this.element = document.createElement('div');
    this.element.className = 'language-switcher';

    const currentLang = i18n.getLanguage();
    const isZh = currentLang === SupportedLanguages.ZH;

    this.element.innerHTML = `
      <button
        class="lang-btn ${isZh ? 'active' : ''}"
        data-lang="${SupportedLanguages.ZH}"
        aria-label="切换至中文"
      >
        中
      </button>
      <span class="lang-divider">/</span>
      <button
        class="lang-btn ${!isZh ? 'active' : ''}"
        data-lang="${SupportedLanguages.EN}"
        aria-label="Switch to English"
      >
        EN
      </button>
    `;

    this.element.addEventListener('click', (e) => {
      const btn = e.target.closest('.lang-btn');
      if (!btn) return;

      const lang = btn.dataset.lang;
      if (lang && lang !== i18n.getLanguage()) {
        i18n.setLanguage(lang);
      }
    });

    this.container.appendChild(this.element);

    this.unsubscribe = i18n.subscribe(() => {
      this.updateActiveState();
    });
  }

  updateActiveState() {
    if (!this.element) return;

    const currentLang = i18n.getLanguage();
    const buttons = this.element.querySelectorAll('.lang-btn');

    buttons.forEach((btn) => {
      const isActive = btn.dataset.lang === currentLang;
      btn.classList.toggle('active', isActive);
    });
  }

  destroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    if (this.element && this.element.parentNode) {
      this.element.parentNode.removeChild(this.element);
    }
    this.element = null;
  }
}
